export const STATUS_OK = 0;
export const STATUS_PRIORITYEXISTS = -1;